import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import HeadingM from "../../components/shared/HeadingM"
import Layout from "../../components/noone/Layout"
import SEO from "../../components/Seo"
import About from "../../components/shared/usage/About"
import Fee from "../../components/shared/usage/Fee"
import Procedure from "../../components/shared/usage/Procedure"
import { PAGE } from "../../constants"

const usage = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.usage} siteTitle="noone" />
      <HeadingL title={PAGE.title.usage} target="noone" />
      <HeadingM title="ご利用について" target="noone" />
      <About />
      <HeadingM title="ご利用料金" target="noone" />
      <Fee target="noone" />
      <HeadingM title="ご利用手順" target="noone" />
      <Procedure target="noone" />
    </Layout>
  )
}

export default usage
